export function otpFormValidation(value){

    let errors = {};
    if(!value.otp){
        errors.otp = 'Otp is required';
    }
    
    return errors;


}